import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'

export default class ProductAnalyticsSortableTh extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick(event) {
    let newDirection

    if (this.props.defaultSortingAsc) {
      newDirection = this.props.direction === 'asc' ? 'desc' : 'asc'
    } else {
      newDirection = this.props.direction === 'desc' ? 'asc' : 'desc'
    }

    this.props.onSortByChange(this.props.attribute, newDirection)
  }

  render() {
    const colSpan = this.props.colSpan || ''

    return (
      <th
        colSpan={colSpan}
        className={`${this.props.className} is-sortable ${this.props.direction ? 'is-active' : ''}`}
        onClick={this.onClick}
      >
        { this.props.children }

        { this.props.direction === 'desc' && (
          <span className="u-ml10">
            <Icon type="arrow-down" color="green-dark" className="sort-icon" />
          </span>
        )}
        { this.props.direction === 'asc' && (
          <span className="u-ml10">
            <Icon type="arrow-up" color="green-dark" className="sort-icon" />
          </span>
        )}
        { !this.props.direction && (
          <span className="u-ml10">
            <Icon type="arrow-down" color="grey" className="sort-icon" />
            <Icon type="arrow-up" color="grey" className="sort-icon" />
          </span>
        )}
      </th>
    )
  }
}
